(() => {
  const SELECTORS = {
    container: '[data-view-more-container]',
    pagination: '[data-view-more-pagination]',
    nextLink: 'a[rel="next"]'
  };

  function getNextUrl(nxtpgcarat) {
    const a = nxtpgcarat?.querySelector(SELECTORS.nextLink);
    return a?.href || null;
  }

  function ensureButton(nxtpgcarat) {
    let btn = document.querySelector('[data-view-more-button]');
    if (btn) return btn;

    btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'button button--primary';
    btn.textContent = 'View more';
    btn.setAttribute('data-view-more-button', '');
    btn.style.justifySelf = 'center';

    // put button just before pagination
    nxtpgcarat.insertAdjacentElement('beforebegin', btn);
    return btn;
  }

  async function loadNext({ productlistele, nxtpgcarat, loadmorebtn }) {
    const nextUrl = getNextUrl(nxtpgcarat);
    if (!nextUrl) {
      loadmorebtn.style.display = 'none';
      return;
    }

    loadmorebtn.disabled = true;
    const prevText = loadmorebtn.textContent;

    try {
      const res = await fetch(nextUrl, { credentials: 'same-origin' });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const html = await res.text();

      const doc = new DOMParser().parseFromString(html, 'text/html');
      const nextContainer = doc.querySelector(SELECTORS.container);
      const nextPagination = doc.querySelector(SELECTORS.pagination);

      if (!nextContainer) throw new Error('Next page container not found');

      // Append items from the next page
      Array.from(nextContainer.children).forEach((node) => productlistele.appendChild(node));

      // Update pagination so the next link advances
      if (nextPagination) nxtpgcarat.innerHTML = nextPagination.innerHTML;

      // If no more pages, remove button
      if (!getNextUrl(nxtpgcarat)) loadmorebtn.style.display = 'none';
    } catch (err) {
      console.error('[View more] error:', err);
      loadmorebtn.textContent = 'Try again';
    } finally {
      loadmorebtn.disabled = false;
    }
  }

  function init() {
    const productlistele = document.querySelector(SELECTORS.container);
    const nxtpgcarat = document.querySelector(SELECTORS.pagination);
    if (!productlistele || !nxtpgcarat) return;

    // remove old button if re-init
    document.querySelectorAll('[data-view-more-button]').forEach((b) => b.remove());

    const nextUrl = getNextUrl(nxtpgcarat);

    const loadmorebtn = ensureButton(nxtpgcarat);
    loadmorebtn.style.display = nextUrl ? 'block' : 'none';
    loadmorebtn.addEventListener('click', () => loadNext({ productlistele, nxtpgcarat, loadmorebtn }));
  }

  document.addEventListener('DOMContentLoaded', init);

  // If Prestige re-renders collection (filters/sort), this often fires:
  document.addEventListener('shopify:section:load', init);

  window.LoadMoreCollection = {
    init,
    loadNext
  };
})();

// Watch for Prestige replacing the collection/pagination DOM
const mo = new MutationObserver(() => {
  // If pagination exists but button doesn't, re-init
  if (
    document.querySelector('[data-view-more-pagination]') &&
    !document.querySelector('[data-view-more-button]')
  ) {
    if (document.querySelector('[data-view-more-pagination]')?.querySelector('a[rel="next"]')){
      window.LoadMoreCollection?.init();
    }
  }
});

mo.observe(document.body, { childList: true, subtree: true });